import Crehana from '@crehana/icons/logos/Crehana';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { colors } from '@crehana/ui';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled from 'styled-components';
import { usePlaybackContext } from "../context/Playback";
import { useResponsiveContext } from "../context/Responsive";
import { useUIContext } from "../context/UI";
import { jsx as _jsx } from "react/jsx-runtime";
var LogoWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-qohghg-0"
})(["\n  ", "\n  ", "\n"], function (_ref) {
  var theme = _ref.theme,
    playerSize = _ref.playerSize,
    visibleSkip = _ref.visibleSkip,
    visibleUi = _ref.visibleUi,
    isStarted = _ref.isStarted;
  return playerSize.matches.md ? "\n        transition: ".concat(theme.transition(['transform', 'opacity'], 300), ";\n        opacity: ").concat(!visibleSkip ? 0.5 : 0, ";\n        transform: translateY(").concat(visibleUi && isStarted ? '-76px' : 0, ");\n      ") : "\n        transition: ".concat(theme.transition('opacity', 300), ";\n        opacity: ").concat(!visibleSkip && !visibleUi ? 0.5 : 0, ";\n      ");
}, function (_ref2) {
  var playerSize = _ref2.playerSize;
  return playerSize.matches.sm ? "\n        bottom: 24px;\n        right: 24px;\n        & > svg {\n          height: 16px;\n          width: 86px;\n        }\n      " : "\n        bottom: 16px;\n        right: 16px;\n        & > svg {\n          height: 12px;\n          width: 65px;\n        }\n      ";
});
var Logo = function Logo() {
  var _useResponsiveContext = useResponsiveContext(),
    playerSize = _useResponsiveContext.playerSize;
  var _usePlaybackContext = usePlaybackContext(),
    visibleSkip = _usePlaybackContext.visibleSkip,
    isStarted = _usePlaybackContext.isStarted;
  var _useUIContext = useUIContext(),
    visibleUi = _useUIContext.visibleUi;
  return /*#__PURE__*/_jsx(LogoWrapper, {
    className: "absolute cp-logo z-2",
    playerSize: playerSize,
    visibleSkip: visibleSkip,
    isStarted: isStarted,
    visibleUi: visibleUi,
    children: /*#__PURE__*/_jsx(Crehana, {
      color: colors.white
    })
  });
};
export default Logo;